import { temAcesso } from '@/shared/auth/temAcesso'

const ExcluirMovimentosEmLote = () => import('./ExcluirMovimentosEmLote.vue')

export default {
    path: 'admin/excluir-movimentos-em-lote',
    name: 'Sgtec_Admin_ExcluirMovimentoEmLote',
    component: ExcluirMovimentosEmLote,
    beforeEnter: (to, from, next) => {
        if (temAcesso('SGTEC-ADMIN-00')) {
            next()
        }
    }
}
